
$views.dashboard = {
	
	display : function($callback) {
		
		this.foldersGrid = new $soupmail.control.grid({
			model : 'folders',
			selector : '#dashboard-folders-recent',
			listArrayKey : 'folders',
			noResultsMessage : '<a href="#" onclick="$controllers.foldermanager.display(function() { $controllers.foldermanager.newFolder(); }); return false">Add a folder to get started</a>',
			paginationFrameSize : 8,
			orderingEnabled : true,
			orderingColumn : 'updated_at',
			orderingSecondaryColumn : 'reference,name',
			columns : [
				{ name:'favourited', label:'<span>Favourites</span>', cssclass:'favourite-icon', layout:'', ordering:'disabled', tipsy:'Favourites', onAfterRender:function(item, obj) {
					if (item.favourited) {
						obj.find('.favourite-icon').addClass('favourite-icon-active');
					}
					obj.find('.favourite-icon').html('');
				} },
				{ name:'last_modified', label:'<span>Recency</span>', cssclass:'recency', layout:' ', ordering:'updated_at', forceOrderingDirection:'desc', tipsy:'Most Recent' },
				{ name:'reference', hidden:true },
				{ name:'name', label:'<span>Display name</span>', cssclass:'folder-list-item', layout:'<div rel="tipsy" class="folder-icon"></div><div class="num"><a href="#">{reference}</a></div><div class="name"><a href="#"><span class="pipe">|</span>{name}</a></div>', ordering:'display_name', forceOrderingDirection:'asc', tipsy:'Alphabetical', onAfterRender:function(item, obj){
					if ($models.login.getTeamid() == item.team.id) {
						if (item.custom_permissions) {
							obj.find('.folder-icon').addClass('specific');
							obj.find('.folder-icon').attr('title', 'Shared with specific people').attr('rel', 'tipsy');
						}else{
							obj.find('.folder-icon').attr('title', 'Shared with my team').attr('rel', 'tipsy');
						}
					}else{
						obj.find('.folder-icon').addClass('another-team');
						obj.find('.folder-icon').attr('title', 'Shared from another team').attr('rel', 'tipsy');
					}
				}  }
			],
			dataWrapperElem : 'div',
			dataRowElem : 'div',
			dataHeaderRowClass : 'toolbar',
			dataHeaderElem : 'div',
			dataItemRowId : 'folder-row-item-{id}',
			dataItemRowClass : 'folder-row',
			dataItemElem : 'div'
			//dataItemsWrapperStart : '<div class="folder-list">',
			//dataItemsWrapperEnd : '</div>'
		});
		this.foldersGrid.change(function() {
			
			// add "title" tag to any folder names exceeding a certain character length
			jQuery('.folder-row .name').each(function() {
				if (jQuery(this).text().length > 20) {
					jQuery(this).attr('title', jQuery(this).find('.data_name').text());
				}
			});
			
			// unbind any existing event handlers
			jQuery('.toolbar .favourite-icon').unbind('click');
			jQuery('.toolbar .recency, .toolbar .folder-list-item').die('click');
			jQuery('.folder-row *').unbind('click');
			jQuery('.folder-row').unbind('dblclick');
			
			// bind all necessary event handlers onto each of the controls
			jQuery('.toolbar .favourite-icon').click(function(e) {
				$models.favouriteFolders.getSize(function(numberOfFavouritedFolders) {
					if ((numberOfFavouritedFolders > 0) && (jQuery('.folder-row').size() > 0)) {
						$views.dashboard.toggleFavouriteFilter();
						$('.tipsy').remove();
					} else {
						$soupmail.notification.message('Click on the &nbsp;<img src="images/folder-star.png" style="vertical-align:middle" />&nbsp; icon beside a folder to make it a favourite');
					}
				});
			});
			jQuery('.toolbar .recency, .toolbar .folder-list-item').live('click', function(e) {
				if ($views.dashboard.foldersGrid.config.model == 'favouriteFolders') {
					if (jQuery(this).hasClass('recency')) {
						$views.dashboard.foldersGrid.config.orderingColumn = 'updated_at';
						$views.dashboard.foldersGrid.config.orderingDirection = 'desc';
					} else if (jQuery(this).hasClass('folder-list-item')) {
						$views.dashboard.foldersGrid.config.orderingColumn = 'display_name';
						$views.dashboard.foldersGrid.config.orderingDirection = 'asc';
					}
					$views.dashboard.unsetFavouriteFolderFilter();
				}
				$('.tipsy').remove();
			});
			jQuery('.folder-row a').click(function(e) {
				e.preventDefault();
			});
			jQuery('.folder-row .favourite-icon').click(function(e) {
				if (!jQuery(this).parent().hasClass('is-new-prepended-folder')) {
					$controllers.dashboard.toggleFavouriteFolder(jQuery(this).parent().attr('data-id'));
				}
			});
			jQuery('.folder-row .folder-list-item a').click(function(e) {
				if (!jQuery(this).parent().parent().parent().hasClass('is-new-prepended-folder')) {
					$controllers.main.display({folder_ids: jQuery(this).parent().parent().parent().attr('data-id')});
					$('.tipsy').remove();
				}
			});
			jQuery('.folder-row').dblclick(function(e) {
				if (!jQuery(this).hasClass('is-new-prepended-folder')) {
					$controllers.main.display({folder_ids: jQuery(this).attr('data-id')});
					$('.tipsy').remove();
				}
			});
			
		});
		this.foldersGrid.load($callback);
		
	},
	
	showTags : function() {
		$models.tags.getList({max_results: 10}, function($data) {
			var $target = '#dashboard-popular-tags .tag-cloud ul';
			$views.dashboard.renderTags($data, $target);
		});
	},
	/*
	showFolders : function() {
		$models.folders.getList({max_results: 8}, function($data) {
			
			// if we don't have any folders returned, lets refresh really frequently, as there *might* be more coming our way soon!
			if ($data.folders.length == 0) {
				$controllers.dashboard.refreshInterval = 2000;
			} else {
				$controllers.dashboard.refreshInterval = 60000;
			}
			
			// display
			var $target = '#dashboard-folders-recent .folder-list';
			$views.dashboard.renderFolders($data, $target);
			
		});
	},
	*/
	showEmails : function() {
		$models.emails.getList({max_results:8}, function($data) {
			var $target = '#dashboard-recent-emails-me .email-list';
			$views.dashboard.renderEmails($data, $target, false);
		});
	},
	/*
	renderFolders : function($data, $target) {
		
		if ($data.folders && ($data.folders.length > 0)) {
			
			var $ajaxHtmlForDiv = '';
			jQuery.each($data.folders, function($key, $folder) {
				
				$ajaxHtmlForDiv += '<div class="folder-row" data-id="'+$folder.id+'">';
				$ajaxHtmlForDiv += '<div id="favourite-'+$folder.id+'" class="favourite-icon"></div>';
				$ajaxHtmlForDiv += '<div id="folder-list-item-'+$folder.id+'" class="folder-list-item">';
				$ajaxHtmlForDiv += '<div class="num"><a href="#">'+$folder.reference+'</a></div>';
				$ajaxHtmlForDiv += '<div class="name"><a href="#"><span class="pipe">|</span>'+$folder.name+'</a></div>';
				$ajaxHtmlForDiv += '</div>';
				$ajaxHtmlForDiv += '</div>';
				
			});
			
			$views.all.handleLoadedAjaxData($ajaxHtmlForDiv, $target, false);
			
			jQuery('.folder-row .favourite-icon').click(function(e) {
				$folderid = jQuery(this).parent().attr('data-id');
				$controllers.dashboard.toggleFavouriteFolder($folderid);
			});
			jQuery('.folder-row .folder-list-item').click(function(e) {
				$folderid = jQuery(this).parent().attr('data-id');
				$controllers.main.display({folder_ids: $folderid});
			});
			jQuery('.folder-row .folder-list-item a').click(function(e) {
				e.preventDefault();
			});
			
			jQuery.each($data.folders, function($key, $folder) {
				if ($folder.favourited === true) {
					jQuery('#favourite-'+$folder.id).addClass('favourite-icon-active');
					$folder.isPopularFolder = true;
				}
			});
			
		} else {
			
			jQuery($target).html('<div class="folder-row"><div class="folder-list-item first-time-user"><p>No folders have been created yet.</p></div></div>');
			
		}
		
	},
	*/
	renderTags : function($data, $target) {
		
		if ($data.tags && ($data.tags.length > 0)) {
			
			var $ajaxHtmlForDiv = '';
			jQuery.each($data.tags, function($key, $tag) {
				$ajaxHtmlForDiv += '<li class="tag-item">';
				$ajaxHtmlForDiv += $tag.name;
				$ajaxHtmlForDiv += '</li>';
			});
			
			$views.all.handleLoadedAjaxData($ajaxHtmlForDiv, $target, false);
			
			jQuery('.tag-item').click(function(e) {
				var $tagname = jQuery(this).text();
				$controllers.main.display({tagid: $tagname, 'filters[tags]': $tagname});
			});
			
		} else {
			jQuery($target).html('<li class="first-time-user">No tags found.</li>');
		}
		
	},
	
	renderEmails : function($data, $target, $appendNewDataToExisting) {
		
		if ($data.emails && ($data.emails.length > 0)) {
			
			// add contacts to cache
			jQuery.each($data.emails, function($key, $email) {
				
				$cached.contacts.add($email.from, 'from', true);
				$cached.contacts.add($email.to, 'to', true);
				$cached.contacts.add($email.cc, 'cc', true);
				
			});
			$cached.contacts.change();
			
			var $ajaxHtmlForDiv = '';
			jQuery.each($data.emails, function($key, $email) {
				
				if (!$email.subject) { $email.subject = '(no subject)'; }
				var $emailClass = ($email.attachments ? 'attachment' : '');
				$email.dateObj = new $soupmail.helpers.SoupMailDate($email.sent_date);
				$ajaxHtmlForDiv += '<div id="item-'+$soupmail.string.stringHtmlAttributeSafe($email.message_id)+'" data-id="'+$email.id+'" data-folder-id="'+$email.folder.id+'" class="email-list-item email-list-item-'+$email.id+'">';
				$ajaxHtmlForDiv += '<h3><a href="#" class="email-list-item-link">'+$soupmail.string.emailAddressHtmlEscape($email.from)+'</a></h3>';
				$ajaxHtmlForDiv += '<div class="date '+$emailClass+'">'+$email.dateObj.getDashboardDate()+'</div>';
				$ajaxHtmlForDiv += '<div class="subject'+($models.emails.getItemInvolvingYou($email) ? ' you' : '')+'"><span>'+$soupmail.string.basicHtmlEscape($email.subject)+'</span></div>';
				$ajaxHtmlForDiv += '<div class="intro">'+$soupmail.string.basicHtmlEscape($email.truncated_body, '')+'</div>';
				$ajaxHtmlForDiv += '</div>';
				
			});
			
			$views.all.handleLoadedAjaxData($ajaxHtmlForDiv, $target, $appendNewDataToExisting);
			$views.all.bindClickHandlersToItems();
			
		} else if ($views.all.getCurrentScreen() == 'dashboard') {
			
			jQuery($target).html('<div class="email-list"><div class="email-list-item first-time-user"><p>No emails have been saved by you or shared with you yet.</p></div></div>');
			
		} else if ($appendNewDataToExisting != true) {
			
			jQuery($target).html('');
			
		}
		
	},
	
	// proxy function to renderEmail() in main view
	renderEmail : function($emailid, $data, $body) {
		
		return $views.main.renderEmail($emailid, $data, $body);
		
	},
	
	toggleFavouriteFilter : function() {
		if (this.foldersGrid.config.model == 'folders') {
			$views.dashboard.setFavouriteFolderFilter();
		} else {
			$views.dashboard.unsetFavouriteFolderFilter();
		}
	},
	
	setFavouriteFolderFilter : function() {
		this.foldersGrid.config.model = 'favouriteFolders';
		this.foldersGrid.config.columns[0].cssclass = 'favourite-icon header-favourite-icon-active';
		this.foldersGrid.config.orderingEnabled = false;
		this.foldersGrid.reset();
		this.foldersGrid.load();
	},
	
	unsetFavouriteFolderFilter : function() {
		this.foldersGrid.config.model = 'folders';
		this.foldersGrid.config.columns[0].cssclass = 'favourite-icon';
		this.foldersGrid.config.orderingEnabled = true;
		this.foldersGrid.reset();
		this.foldersGrid.load();
	},
	
	gettingStarted : function() {
			
		if (!$models.login.hasSyncEnabled()) {
			$controllers.all.help(true);
			jQuery('#welcome-header').hide();
		}
		
	}
	
};



// WEBPACK FOOTER //
// ./src/js/views/desktop.dashboard.js